import React, { useState, useEffect, useRef } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { createTicket, updateTicket, getActiveEmployees, getProjectModules } from "../../../../api/ticketing";
import { getAllClients } from "../../../../api/client";
import { toast } from "react-toastify";
import { getPriorities, getCategories } from "../../../../api/masterOptions";

const EMPTY = {
  ticketType: "", instituteId: "", module: "", moduleId: null, priority: "",
  title: "", description: "", remark: "", assigneeId: null,
  dueDate: "", status: "New",
};

const inputStyle = {
  borderRadius: 8, fontSize: 14,
  background: "#fff", border: "1px solid #e5e7eb",
};

const CreateTicketModal = ({ show, onHide, onSaved, editTicket = null }) => {
  const attachmentOnly = !!editTicket?.attachmentOnly;
  const myUserId = Number(localStorage.getItem("id"));
  const roleId = localStorage.getItem("roleId");
  const isAdmin = roleId !== "3";
  const canEdit = isAdmin || editTicket?.createdById === myUserId; const token = localStorage.getItem("token");
  const [form, setForm] = useState(EMPTY);
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);
  const [files, setFiles] = useState([]);
  const [existingAttachments, setExistingAttachments] = useState([]);
  const fileInputRef = useRef(null);
  const [employees, setEmployees] = useState([]);
  const [clients, setClients] = useState([]);
  const [modules, setModules] = useState([]);
  const [priorities, setPriorities] = useState([]);
  const [ticketTypes, setTicketTypes] = useState([]);
  const initialFormRef = useRef(null);

  useEffect(() => {
    getPriorities(token).then(res => setPriorities(res.data || [])).catch(() => { });
    getCategories(token).then(res => setTicketTypes(res.data || [])).catch(() => { });
  }, [token]);

  useEffect(() => {
    getActiveEmployees(token)
      .then(res => setEmployees(res.data))
      .catch(() => { });
  }, [token]);

  useEffect(() => {
    getAllClients(token)
      .then(res => {
        console.log("API Response:", res);
        console.log("Response Data:", res.data);

        const activeClients = (res.data || []).filter(
          c => c.status === "Active"
        );

        console.log("Active Clients:", activeClients);
        setClients(res.data);
      })
      .catch(error => {
        console.error("Error fetching clients:", error);
      });
  }, [token]);
  useEffect(() => {
    getProjectModules(token)
      .then(res => setModules(res.data.filter(m => m.status !== "Inactive")))
      .catch(() => { });
  }, [token]);

  useEffect(() => {
    if (show) {
      const initialForm = editTicket
        ? {
          ...EMPTY,
          ...editTicket,
          ticketType: editTicket.ticketType ?? "",
          module: editTicket.module ?? "",
          priority: editTicket.priority ?? "",
          title: editTicket.title ?? "",
          description: editTicket.description ?? "",
          remark: editTicket.remark ?? "",
          assigneeId: editTicket.assigneeId || null,
        }
        : { ...EMPTY, assigneeId: myUserId || null };
      setForm(initialForm);
      initialFormRef.current = initialForm;
      setErrors({});
      setFiles([]);
      setExistingAttachments(editTicket?.attachments || []);
    }
  }, [show, editTicket]);

  const isValidText = (value) => {
    const trimmed = (value || "").trim();
    if (!trimmed) return false;
    const hasLetter = /[A-Za-z]/.test(trimmed);
    return hasLetter;
  };

  const set = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));

    let error = "";

    if (["title", "description", "remark"].includes(field)) {
      if (value.trim()) {
        if (!isValidText(value)) {
          error = "Please enter valid text";
        }
      }
    }

    setErrors(prev => ({
      ...prev,
      [field]: error,
    }));
  };

  const validate = () => {
    const e = {};

    if (!form.ticketType)
      e.ticketType = "Ticket Type is required";

    if (!form.instituteId)
      e.instituteId = "Client is required";

    if (!(form.module || "").trim())

      e.module = "Module is required";

    if (!form.priority)
      e.priority = "Priority is required";

    if (!(form.title || "").trim())
      e.title = "Ticket Title is required";
    else if (!isValidText(form.title))
      e.title = "Please enter valid Ticket Title";

    if (!(form.description || "").trim())
      e.description = "Description is required";
    else if (!isValidText(form.description))
      e.description = "Please enter valid Description";

    if ((form.remark || "").trim() && !isValidText(form.remark))
      e.remark = "Please enter valid Remark";

    if (!form.assigneeId)
      e.assigneeId = "Assignee is required";

    return e;
  };

  const handleSubmit = async () => {
    const e = attachmentOnly ? {} : validate();
    if (Object.keys(e).length) { setErrors(e); return; }

    if (editTicket?.id) {
      const { attachments: _a1, ...current } = form;
      const { attachments: _a2, ...original } = initialFormRef.current || {};
      const formChanged = JSON.stringify(current) !== JSON.stringify(original);
      const attachmentsRemoved =
        existingAttachments.length !== (editTicket?.attachments || []).length;

      if (!formChanged && files.length === 0 && !attachmentsRemoved) {
        toast.info("No changes made");
        return;
      }
    }

    setSaving(true);
    try {
      const { attachments, ...ticketPayload } = form;
      const fd = new FormData();
      fd.append("ticket", JSON.stringify(ticketPayload));
      files.forEach(f => fd.append("files", f));

      let res;
      if (editTicket?.id) {
        res = await updateTicket(editTicket.id, fd, token);
        toast.success("Ticket updated successfully");
      } else {
        res = await createTicket(fd, token);
        toast.success("Ticket created successfully");
      }
      onSaved(res?.data);
      onHide();
    } catch {
      toast.error("Something went wrong");
    } finally {
      setSaving(false);
    }
  };

  const labelStyle = { fontWeight: 600, fontSize: 14, color: "#1a1a2e" };

  return (
    <>
      <Modal show={show} onHide={onHide} centered size="lg">
        <Modal.Header closeButton style={{ borderBottom: "none", padding: "24px 28px 4px" }}>
          <Modal.Title style={{ fontSize: "1.2rem", fontWeight: 700, color: "#1a1a2e" }}>
            {editTicket ? "Edit Ticket" : "Create New Ticket"}
          </Modal.Title>
        </Modal.Header>

        <div style={{ padding: "0 28px 4px" }}>
          <p style={{ color: "#6b7280", fontSize: 13, margin: 0 }}>
            {editTicket ? "Update the ticket details below." : "Fill in the details to create a new ticket."}
          </p>
        </div>

        <Modal.Body style={{ padding: "16px 28px 8px", maxHeight: "65vh", overflowY: "auto" }}>
          <Row className="g-3">

            {/* Row 1: Ticket Type + Client Name */}
            <Col xs={6}>
              <Form.Group>
                <Form.Label style={labelStyle}>Ticket Type <span style={{ color: "#e53e3e" }}>*</span></Form.Label>
                <Form.Select
                  value={form.ticketType}
                  onChange={e => {
                    const t = ticketTypes.find(x => x.category === e.target.value);
                    set("ticketType", e.target.value);
                    set("categoryId", t ? t.id : null);
                  }}
                  isInvalid={!!errors.ticketType}
                  disabled={attachmentOnly}
                  style={{ ...inputStyle, height: 40, background: attachmentOnly ? "#f3f4f6" : "#fff" }}
                >
                  <option value="">Select type</option>
                  {ticketTypes.map(t => <option key={t.id} value={t.category}>{t.category}</option>)}
                </Form.Select>
                <Form.Control.Feedback type="invalid">{errors.ticketType}</Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col xs={6}>
              <Form.Group>
                <Form.Label style={labelStyle}>Client Name <span style={{ color: "#e53e3e" }}>*</span></Form.Label>
                <Form.Select
                  value={form.instituteId || ""}
                  onChange={e => set("instituteId", e.target.value ? Number(e.target.value) : "")}
                  isInvalid={!!errors.instituteId}
                  disabled={attachmentOnly}
                  style={{ ...inputStyle, height: 40, background: attachmentOnly ? "#f3f4f6" : "#fff" }}
                >
                  <option value="">Select client</option>
                  {clients.map(c => (
                    <option key={c.id} value={c.id}>
                      {c.instituteName}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">{errors.instituteId}</Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* Row 2: Module + Priority */}
            <Col xs={6}>
              <Form.Group>
                <Form.Label style={labelStyle}>Module <span style={{ color: "#e53e3e" }}>*</span></Form.Label>
                <Form.Select
                  value={form.moduleId ?? modules.find(m => m.projectModuleName === form.module)?.moduleId ?? ""}
                  onChange={e => {
                    const m = modules.find(x => String(x.moduleId) === e.target.value);
                    set("moduleId", m ? m.moduleId : null);
                    set("module", m ? m.projectModuleName : "");
                  }}
                  isInvalid={!!errors.module}
                  disabled={attachmentOnly}
                  style={{ ...inputStyle, height: 40, background: attachmentOnly ? "#f3f4f6" : "#fff" }}
                >
                  <option value="">Select module</option>
                  {modules.map(m => (
                    <option key={m.moduleId} value={m.moduleId}>
                      {m.projectModuleName}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">{errors.module}</Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col xs={6}>
              <Form.Group>
                <Form.Label style={labelStyle}>Priority <span style={{ color: "#e53e3e" }}>*</span></Form.Label>
                <Form.Select
                  value={form.priority}
                  onChange={e => {
                    const p = priorities.find(x => x.priority === e.target.value);
                    set("priority", e.target.value);
                    set("priorityId", p ? p.id : null);
                  }}
                  isInvalid={!!errors.priority}
                  disabled={attachmentOnly}
                  style={{
                    ...inputStyle,
                    height: 40,
                    background: attachmentOnly ? "#f3f4f6" : "#fff"
                  }}
                >
                  <option value="">Select priority</option>
                  {priorities.map(p => <option key={p.id} value={p.priority}>{p.priority}</option>)}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors.priority}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* Row 3: Ticket Title (full width) */}
            <Col xs={12}>
              <Form.Group>
                <Form.Label style={labelStyle}>Ticket Title <span style={{ color: "#e53e3e" }}>*</span></Form.Label>
                <Form.Control
                  value={form.title}
                  onChange={e => set("title", e.target.value)}
                  isInvalid={!!errors.title}
                  disabled={attachmentOnly}
                  maxLength={255}
                  style={{ ...inputStyle, height: 40, background: attachmentOnly ? "#f3f4f6" : "#fff" }}
                />
                <Form.Control.Feedback type="invalid">{errors.title}</Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* Row 4: Ticket Description */}
            <Col xs={12}>
              <Form.Group>
                <Form.Label style={labelStyle}>Ticket Description <span style={{ color: "#e53e3e" }}>*</span></Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="description..."
                  value={form.description}
                  onChange={e => set("description", e.target.value)}
                  isInvalid={!!errors.description}
                  disabled={attachmentOnly}
                  style={{ ...inputStyle, resize: "vertical", background: attachmentOnly ? "#f3f4f6" : "#fff" }}
                />
                <Form.Control.Feedback type="invalid">{errors.description}</Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* Row 5: Remark */}
            <Col xs={12}>
              <Form.Group>
                <Form.Label style={labelStyle}>Remark</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  value={form.remark}
                  onChange={e => set("remark", e.target.value)}
                  isInvalid={!!errors.remark}
                  style={{ ...inputStyle, resize: "vertical" }}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.remark}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* Row 6: Assignee single select */}
            <Col xs={12}>
              <Form.Group>
                <Form.Label style={labelStyle}>Assignee <span style={{ color: "#e53e3e" }}>*</span></Form.Label>
                <Form.Select
                  value={form.assigneeId || ""}
                  onChange={e =>
                    set(
                      "assigneeId",
                      e.target.value ? parseInt(e.target.value) : null
                    )
                  }
                  isInvalid={!!errors.assigneeId}
                  disabled={attachmentOnly}
                  style={{ ...inputStyle, height: 40, background: attachmentOnly ? "#f3f4f6" : "#fff" }}
                >
                  <option value="">Assign user</option>
                  {employees.map(emp => (
                    <option key={emp.id} value={emp.id}>
                      {emp.name}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors.assigneeId}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* Row 7: Attachments drop zone */}
            <Col xs={12}>
              <Form.Label style={labelStyle}>Attachments</Form.Label>

              {/* Show existing attachments in edit mode */}
              {editTicket && existingAttachments.length > 0 && (
                <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 8 }}>
                  {existingAttachments.map((att, i) => (
                    <span key={att.id || i} style={{
                      background: "#dbeafe", color: "#1d4ed8",
                      borderRadius: 6, fontSize: 12, padding: "3px 10px",
                      display: "flex", alignItems: "center", gap: 6,
                    }}>
                      📎 {att.fileName || att.name || (typeof att === "string" ? att : "attachment")}
                      {canEdit && (
                        <span
                          onClick={() => setExistingAttachments(prev => prev.filter((_, idx) => idx !== i))}
                          style={{ cursor: "pointer", fontWeight: 700 }}
                        >×</span>
                      )}
                    </span>
                  ))}
                </div>
              )}
              <div
                onClick={() => fileInputRef.current.click()}
                onDragOver={e => { e.preventDefault(); e.currentTarget.style.background = "#eff6ff"; }}
                onDragLeave={e => { e.currentTarget.style.background = "#f8f9ff"; }}
                onDrop={e => {
                  e.preventDefault();
                  e.currentTarget.style.background = "#f8f9ff";
                  setFiles(prev => [...prev, ...Array.from(e.dataTransfer.files)]);
                }}
                style={{
                  border: "1.5px dashed #c7d2fe",
                  borderRadius: 8,
                  background: "#f8f9ff",
                  minHeight: 72,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#9ca3af",
                  fontSize: 13,
                  cursor: "pointer",
                  gap: 4,
                  transition: "background 0.2s",
                }}
              >
                <span style={{ fontSize: 20 }}>📎</span>
                <span>Drop files here or click to upload</span>
              </div>
              <input
                ref={fileInputRef}
                type="file"
                multiple
                style={{ display: "none" }}
                onChange={e => setFiles(prev => [...prev, ...Array.from(e.target.files)])}
              />
              {files.length > 0 && (
                <div style={{ marginTop: 8, display: "flex", flexWrap: "wrap", gap: 6 }}>
                  {files.map((f, i) => (
                    <span key={i} style={{
                      background: "#dbeafe", color: "#1d4ed8",
                      borderRadius: 6, fontSize: 12, padding: "3px 10px",
                      display: "flex", alignItems: "center", gap: 6,
                    }}>
                      {f.name}
                      <span
                        onClick={() => setFiles(prev => prev.filter((_, idx) => idx !== i))}
                        style={{ cursor: "pointer", fontWeight: 700 }}
                      >×</span>
                    </span>
                  ))}
                </div>
              )}
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer style={{ borderTop: "none", padding: "8px 28px 24px", gap: 12 }}>
          <Button
            variant="outline-secondary"
            onClick={onHide}
            style={{ borderRadius: 8, minWidth: 100, fontWeight: 500, color: "#374151", borderColor: "#d1d5db", background: "#fff" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            disabled={saving}
            style={{ borderRadius: 8, minWidth: 120, fontWeight: 600, background: "#2E5CB8", border: "none" }}
          >
            {saving ? "Saving..." : editTicket ? "Update" : "Create Ticket"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CreateTicketModal;
